import { FC } from 'react';
import { Empty, Typography } from 'antd';

import { ActionButton } from '../ActionButton';

import styles from './styles.module.css';

const { Text } = Typography;

interface Props {
    title?: string;
    description?: string;
    actionLabel: string;
    onAction: () => void;
}

export const ErrorLoad: FC<Props> = ({ title, description, actionLabel, onAction }) => (
    <div className={styles.errorLoad}>
        <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            className={styles.empty}
            description={
                <div className={styles.textContent}>
                    {title && <Text className={styles.title}>{title}</Text>}
                    {description && <Text className={styles.description}>{description}</Text>}
                </div>
            }
        >
            <div className={styles.actionWrapper}>
                <ActionButton onClick={onAction}>{actionLabel}</ActionButton>
            </div>
        </Empty>
    </div>
);
